<template>
	<div class="root mobile-tablet-portrait-make-scrollable">
		<div v-if="this.mapNodes == null" style="height: 100%;">
			<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
				<b-spinner style="display: block;"/>
			</div>
		</div>
		<div v-else-if="bgType=='default' || bgType=='image'" style="background-color: #D9D2CC; width: 100%; height: 100%;" ref="mapRoot">
			<div role="heading" aria-level="5" aria-label="project image" style="position: absolute; width: 95%; height: 90%; overflow: hidden !important; pointer-events: none"></div>
			<div v-if="imageWidth > 0" @click.self="rootClick" class="centered image-bg" :style="`background-size: contain; max-width: 100%; max-height: 100%; width: ${imageWidth}px; height: ${imageHeight}px; background-image: url(${bgImage}); background-repeat:no-repeat; background-position: center center;`" ref="defImageRoot">
				<template v-for="(mapNode, key) in this.mapNodes">
					<!-- 	v-if="mapNode[1].position"-->
					<div class="mappin-root"
						:key="key"
						:style="`left: calc(${clamp(mapNode[1].position.x, 0, 1) * 100}% + 20px); top: calc(${(1 - clamp(mapNode[1].position.y, 0, 1)) * 100}% - 20px); transform: scale(${imageWidth / 1024});`">
						<div 
							class="mappin"
							tabindex="0"
							role="button"
							@click="nodeClick(mapNode)"
							v-on:keydown.enter="nodeClick(mapNode)"
							:aria-label="mapNode[1].name">
						<div class="mappin-text" aria-hidden="true">{{mapNode[1].name}}</div>
						<div class="mappin-img"/>
						</div>
					</div>
				</template>
			</div>
			<div v-else style="height: 100%;">
				<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
					<b-spinner v-if="bgImage" style="display: block;"/>
					<h3 v-else>No map URL provided</h3>
				</div>
			</div>
		</div>
		<div v-else-if="bgType=='none'" style="height: 100%">
			<h3 style="color:#6f7989; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">(no map)</h3>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import store from '@/store/store';

import { mapGetters } from 'vuex';
import project from '../../store/modules/project';
//import { Math } from 'three';

export default Vue.extend(
{
	props: {
		projectData: Object,
		mapNodes: null
	},
	refs: ["mapRoot", "defImageRoot"],
	data(){
		return {
			generation: false,
			imgGeneration: false,
			updateTimer: -1
		}
	},
	computed: 
	{
		bgType() {
			let type = (this.projectData).type;
			if (type == undefined || !type)
			{
				return "default";
			}
			return type;
		},
		bgImage() {
			switch(this.bgType)
			{
			case "image":
				return this.projectData.background_image;
			case "default":
				return "/maps/default_world_map.jpg"
			case "map":
				return ""
			}
			return ""
		},
		bgImgAspectRatio(){
			let img = this.bgImageObj;
			return img.width / img.height;
		},
		bgImgWidthLarger(){
			let img = this.bgImageObj;
			return img.width >= img.height;
		},
		bgImageObj() {
			if ((this.imgGeneration && !this.imgGeneration))
			{
				console.log("wat");
			}
			
			let img = new Image();
			img.src = this.bgImage;
			
			// Will only be 0 if the image has 0 size (in which case, why is it being used at all?) or
			// if it's in the browser cache
			if (img.width == 0)
			{
				// Update everything dependent on this once loading is complete the first time
				// After that, it's synchronous as the image is in the browser cache
				img.onload = ()=>{
					this.imgGeneration = !this.imgGeneration
					this.$forceUpdate();
				}
			}
			return img;
		},
		imageWidth() {
			let img = this.bgImageObj;
			let root = this.$refs.mapRoot;
			if (!root || (this.generation && !this.generation))
			{
				return img.width;
			}

			if (this.bgImgWidthLarger)
			{
				return root.clientHeight * this.bgImgAspectRatio;
			}
			return root.clientWidth;
		},
		imageHeight() {
			//let img = this.bgImageObj as HTMLImageElement;
			let img = this.bgImageObj;
			let root = this.$refs.mapRoot;
			if (!root || (this.generation && !this.generation))
			{
				return img.height;
			}
			if (this.bgImgWidthLarger)
			{
				return root.clientHeight;
			}
			return root.clientWidth / this.bgImgAspectRatio;
			//return Math.min(img.height, root.clientHeight);
			//return (<number>this.imageWidth()) * (img.height / img.width);
		},
	},
	methods: 
	{
		clamp(val, min, max)
		{
			return Math.min(Math.max(val, min), max);
		},

		mapWidth() {
			let ref = this.$refs.defImageRoot;
			if (!ref)
				return 800;
			return ref.clientWidth
		},
		mapHeight() {
			let ref = this.$refs.defImageRoot;
			if (!ref)
				return 600;
			return ref.clientHeight
		},
		rootClick(ev)
		{
			/** @type {Element} */
			let el = ev.srcElement;
			let relX = ev.offsetX / el.clientWidth;
			let relY = ev.offsetY / el.clientHeight;
			this.$emit("background-click", relX, relY)
		},
		nodeClick(node)
		{
			this.$emit("node-click", node[1])
		}
	},
	mounted(){
		let lastVal = this.$refs.mapRoot;
		let lastW = lastVal != null ? lastVal.clientWidth : 0;
		let lastH = lastVal != null ? lastVal.clientHeight : 0;
		
		// This interval allows for reactiviy when the size of the root element is changed
		// Basically all it does is compare the values to the previous tick and, if they're
		// different, tells the associated variables to update
		this.updateTimer = setInterval(()=>{
			/** @type {HTMLImageElement} */
			let img = this.bgImage;
			
			let curVal = this.$refs.mapRoot;
			if (lastVal != curVal ||
				(curVal &&
					(lastW != curVal.clientWidth ||
					lastH != curVal.clientHeight)
				))
			{
				this.generation = !this.generation;
				this.$forceUpdate();
				
				lastVal = curVal;
				lastW = lastVal != null ? lastVal.clientWidth : 0;
				lastH = lastVal != null ? lastVal.clientHeight : 0;
			}
		}, 16);
	},
	beforeDestroy(){
		clearInterval(this.updateTimer);
	}
})
</script>


<style lang="scss" scoped>

.root
{
	width: 100%;
	height: 100%;
	overflow: visible;
	@media only screen and (orientation:portrait){
		overflow: scroll;
	}
}

.mappin-root
{
	width: 40px;
	height: 40px;
	margin-left: -40px;
	margin-bottom: -40px;
	position: relative;
}

.mappin
{
	width: 40px;
	height: 40px;
	color: rgb(243, 243, 243);
	text-shadow: 0px 0px 6px rgba(0,0,0,0.95);
	transition: 300ms;
}

.mappin-img
{
	transition: 100ms;
	width: 100%;
	height: 100%;
	background-image: url("../../assets/icons/map_pin.png");
	background-size: 100% 100%;
}

.mappin-img:hover
{
	transition: 100ms;
	filter: brightness(1.15) contrast(140%) saturate(80%);
}

.mappin:hover
{
	cursor: pointer;
	color: rgb(255, 255, 255);
	transition: 200ms;
	transform: scale(1.15);
}

.mappin:focus
{
	transition: 200ms;
	outline: #427ad6 solid 4px;
}

.mappin-text
{
	font-weight: 500;
	transition: 100ms;
	position: absolute;
	font-size: 30px;
	text-align: center;
	top: -45px;
	width: 200px;
	left: -80px;
	-webkit-text-stroke-width: .1px;
  	-webkit-text-stroke-color: black;
}

.mappin-text:hover
{
	cursor: default;
	color: #fff;
	text-shadow: 0px 0px 8px black;
}

.map-container-root
{
	background-color: #efeceb;
	width: 100%;
	height: 60vh;
	overflow: hidden;
}

.centered
{
	margin: auto;
}

.image-bg
{
	background-size: 100% 100%;
	width: 100%;
	height: 100%;
}
</style>